﻿jQuery("nav.main-navigation button.readspeaker-icon").bind("click", function () {
    jQuery("#readspeaker_button1").removeAttr("style");
    jQuery("#readspeaker_button1 .rsbtn_play .rsbtn_left.rsimg.rspart").click();
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/ReadSpeak/HtoReadSpeak.js
// module id = 19
// module chunks = 1